import { render, staticRenderFns } from "./PessoaFilterBar.vue?vue&type=template&id=7c0d0163"
import script from "./PessoaFilterBar.vue?vue&type=script&lang=js"
export * from "./PessoaFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports